import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Box,
} from "@mui/material";
import {
  MdDashboard,
  MdMenu,
  MdMenuOpen,
  MdLanguage,
  MdAccountCircle,
  MdLogout,
  MdArrowDropDown,
} from "react-icons/md";
import i18n from "../../i18";
import Cookies from "js-cookie";
import {
  FaUserGraduate,
  FaBook,
  FaTshirt,
  FaChalkboardTeacher,
  FaMoneyBillAlt,
  FaChartLine,
  FaUser,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../Styles/Navbar.css";
import kurdish from "../Images/flag.png";
import iraq from "../Images/iraq.png";
import UK from "../Images/united-kingdom.png";
import Nursery from "../Images/Nursery.png";
import PrimaryShool from "../Images/PrimaryShool.png";
import SecondarySchool from "../Images/SecondarySchool.png";
import { Divider } from "antd";

const SideBar = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const userRole = user?.role;
  const { t } = useTranslation();

  const [collapsed, setCollapsed] = useState(false);
  const toggleSidebar = () => setCollapsed(!collapsed);

  const [anchorEl, setAnchorEl] = useState(null);
  const [profileAnchorEl, setProfileAnchorEl] = useState(null);
  const [selectedImage, setSelectedImage] = useState(Nursery);
  // eslint-disable-next-line no-unused-vars
  const [language, setLanguage] = useState("English");

  useEffect(() => {
    const loadUserData = () => {
      const branchId = user?.branch_id || 2;
      const branchImages = {
        1: Nursery,
        2: PrimaryShool,
        3: SecondarySchool,
      };
      setSelectedImage(branchImages[branchId] || Nursery);
    };

    loadUserData();
  }, [user]);

  useEffect(() => {
    const savedLang = Cookies.get("language");
    if (savedLang) {
      setLanguage(savedLang);
      i18n.changeLanguage(savedLang);
    }
  }, []);

  const onChangeLang = (selectedLang) => {
    setLanguage(selectedLang);
    i18n.changeLanguage(selectedLang);
    Cookies.set("language", selectedLang); // Save selected language to a cookie
    localStorage.removeItem("i18nextLng"); // Remove stored language to reset it
  };

  const handleProfileMenuClick = (event) => {
    setProfileAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setProfileAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = "/login"; // Redirect to login
    handleProfileMenuClose();
  };

  const handleLanguageMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLanguageMenuClose = (language) => {
    onChangeLang(language);
    setAnchorEl(null);
  };

  return (
    <Box
      className="no-print"
      sx={{
        width: collapsed ? "60px" : "250px",
        height: "100vh",
        backgroundColor: "#ffffff",
        color: "#2c3e50",
        paddingTop: "20px",
        overflowY: "auto",
        boxShadow: "2px 0 10px rgba(0, 0, 0, 0.1)",
        transition: "width 0.3s ease-in-out",
        borderRight: "1px solid #e0e0e0",
      }}
    >
      <List>
        <ListItem>
          <ListItemIcon sx={{ color: "#2c3e50" }}>
            <img
              src={selectedImage}
              alt="Branch"
              width={collapsed ? 25 : 45}
              height={collapsed ? 25 : 45}
            />
          </ListItemIcon>
          {!collapsed && (
            <ListItemText
              primary={
                <Typography
                  noWrap
                  variant="h6"
                  sx={{ fontWeight: 800, fontSize: "20px" }}
                >
                  Clever School
                </Typography>
              }
            />
          )}
        </ListItem>

        <Divider></Divider>
        <ListItem
          component={Link}
          to="/"
          sx={{ "&:hover": { backgroundColor: "#f5f5f5" }, textDecoration: "none", color: "inherit" }}
        >
          <ListItemIcon sx={{ color: "#2c3e50" }}>
            <MdDashboard size={20} />
          </ListItemIcon>
          {!collapsed && <ListItemText primary={t("dashboard")} />}
        </ListItem>
        {userRole !== "dataentry" && (
          <ListItem
            component={Link}
            to="/GetUser"
            sx={{ "&:hover": { backgroundColor: "#f5f5f5" }, textDecoration: "none", color: "inherit" }}
          >
            <ListItemIcon sx={{ color: "#2c3e50" }}>
              <FaUser size={20} />
            </ListItemIcon>
            {!collapsed && <ListItemText primary={t("users")} />}
          </ListItem>
        )}
        <ListItem
          component={Link}
          to="/GetStudent"
          sx={{ "&:hover": { backgroundColor: "#f5f5f5" }, textDecoration: "none", color: "inherit" }}
        >
          <ListItemIcon sx={{ color: "#2c3e50" }}>
            <FaUserGraduate size={20} />
          </ListItemIcon>
          {!collapsed && <ListItemText primary={t("students")} />}
        </ListItem>

        <ListItem
          component={Link}
          to="/GetTeacher"
          sx={{ "&:hover": { backgroundColor: "#f5f5f5" }, textDecoration: "none", color: "inherit" }}
        >
          <ListItemIcon sx={{ color: "#2c3e50" }}>
            <FaChalkboardTeacher size={20} />
          </ListItemIcon>
          {!collapsed && <ListItemText primary={t("teachers")} />}
        </ListItem>

        {userRole !== "dataentry" && (
          <ListItem
            component={Link}
            to="/GetExpenses"
            sx={{ "&:hover": { backgroundColor: "#f5f5f5" }, textDecoration: "none", color: "inherit" }}
          >
            <ListItemIcon sx={{ color: "#2c3e50" }}>
              <FaMoneyBillAlt size={20} />
            </ListItemIcon>
            {!collapsed && <ListItemText primary={t("expenses")} />}
          </ListItem>
        )}

        <ListItem
          component={Link}
          to="/GetProducts"
          sx={{ "&:hover": { backgroundColor: "#f5f5f5" }, textDecoration: "none", color: "inherit" }}
        >
          <ListItemIcon sx={{ color: "#2c3e50" }}>
            <FaTshirt size={20} />
          </ListItemIcon>
          {!collapsed && <ListItemText primary={t("uniforms")} />}
        </ListItem>

        <ListItem
          component={Link}
          to="/get-books"
          sx={{ "&:hover": { backgroundColor: "#f5f5f5" }, textDecoration: "none", color: "inherit" }}
        >
          <ListItemIcon sx={{ color: "#2c3e50" }}>
            <FaBook size={20} />
          </ListItemIcon>
          {!collapsed && <ListItemText primary={t("books")} />}
        </ListItem>

        {userRole !== "dataentry" && (
          <ListItem
            component={Link}
            to="/Raptors"
            sx={{ "&:hover": { backgroundColor: "#f5f5f5" }, textDecoration: "none", color: "inherit" }}
          >
            <ListItemIcon sx={{ color: "#2c3e50" }}>
              <FaChartLine size={20} />
            </ListItemIcon>
            {!collapsed && <ListItemText primary={t("raptors")} />}
          </ListItem>
        )}
      </List>

      {/* Collapse button */}
      <IconButton
        onClick={toggleSidebar}
        sx={{
          color: "#2c3e50",
          marginLeft: collapsed ? "5px" : "200px",
          transition: "margin 0.3s ease-in-out",
        }}
      >
        {collapsed ? <MdMenu size={24} /> : <MdMenuOpen size={24} />}
      </IconButton>

      {/* Profile button */}
      <Box sx={{ position: "absolute", bottom: "20px", width: "100%" }}>
        <ListItem
          component="div"
          role="button"
          tabIndex={0}
          onClick={handleProfileMenuClick}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleProfileMenuClick(e); } }}
          sx={{ "&:hover": { backgroundColor: "#f5f5f5" }, cursor: "pointer" }}
        >
          <ListItemIcon sx={{ color: "#2c3e50" }}>
            <MdAccountCircle size={25} />
          </ListItemIcon>
          {!collapsed && <ListItemText primary={user?.username ?? ""} />}
          {!collapsed && <MdArrowDropDown size={20} />}
        </ListItem>

        {/* Profile Menu */}
        <Menu
          id="profile-menu"
          anchorEl={profileAnchorEl}
          keepMounted
          open={Boolean(profileAnchorEl)}
          onClose={handleProfileMenuClose}
        >
          {/* Profile MenuItem with Icon */}
          <Link
            to="/Profile"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <MenuItem onClick={handleProfileMenuClose}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <MdAccountCircle size={20} />
                <Typography variant="body1">Profile</Typography>
              </Box>
            </MenuItem>
          </Link>

          {/* Language Selector MenuItem */}
          <MenuItem onClick={handleLanguageMenuClick}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <MdLanguage size={20} />
              <Typography variant="body1">Language</Typography>
            </Box>
          </MenuItem>

          {/* Language Select Dropdown */}
          <Menu
            id="language-select-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
            MenuListProps={{ sx: { padding: 0 } }}
          >
            <MenuItem onClick={() => handleLanguageMenuClose("en")}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <img src={UK} alt="UK Flag" width={30} height={30} />
                <span style={{ marginLeft: "10px" }}>English</span>
              </div>
            </MenuItem>
            <MenuItem onClick={() => handleLanguageMenuClose("ku")}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <img src={kurdish} alt="Kurdish Flag" width={30} height={30} />
                <span style={{ marginLeft: "10px" }}>کوردی</span>
              </div>
            </MenuItem>
            <MenuItem onClick={() => handleLanguageMenuClose("ar")}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <img src={iraq} alt="Iraq Flag" width={30} height={30} />
                <span style={{ marginLeft: "10px" }}>العربية</span>
              </div>
            </MenuItem>
          </Menu>

          {/* Logout MenuItem with Icon */}
          <MenuItem onClick={handleLogout}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <MdLogout size={20} />
              <Typography variant="body1">Logout</Typography>
            </Box>
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
};

export default SideBar;
